/**
 * @generated SignedSource<<9683f9dc365ae9f7ffa089dd96790b0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicHeaderRelatedLinksTopic$data = {
  readonly relatedLink: ReadonlyArray<{
    readonly title: string;
    readonly url: string;
  } | null> | null;
  readonly " $fragmentType": "topicHeaderRelatedLinksTopic";
};
export type topicHeaderRelatedLinksTopic$key = {
  readonly " $data"?: topicHeaderRelatedLinksTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicHeaderRelatedLinksTopic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicHeaderRelatedLinksTopic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TopicRelatedLink",
      "kind": "LinkedField",
      "name": "relatedLink",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Topic",
  "abstractKey": null
};

(node as any).hash = "1d63ca5295553947ce1d011dc7aff884";

export default node;
